'use client';
import { CloseIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import { factory } from '../../factory/factory.utils.mjs';
import { Typography } from '../../Foundations/Typography/Typography.mjs';
import { useId } from '../../Inputs/Dropdown/subcomponent/Combobox/use-id.mjs';
import { Flex } from '../../Layout/Flex/Flex.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import { useUncontrolled } from '../../utils/hooks/use-uncontrolled.mjs';
import { Popover } from '../subcomponents/Popover/Popover.mjs';
import classes from './Coachmark.module.css.mjs';
import { coachmarkSizeClassNames, coachmarkWrapperClassNames } from './Coachmark.utils.mjs';

const Coachmark = factory((props, ref) => {
  const {
    variant = "default",
    target,
    dropdown,
    position,
    size = "big",
    withArrow = true,
    className,
    targetCTA,
    closeCTA,
    opened,
    defaultOpened = false,
    onChange,
    disabled,
    ...rest
  } = props;
  const [dropdownOpened, setDropdownOpened] = useUncontrolled({
    value: opened,
    defaultValue: defaultOpened,
    finalValue: false,
    onChange
  });
  const isDefault = variant === "default";
  const contentColor = isDefault ? classes.secondaryContent : classes.infoContent;
  const id = useId();
  return /* @__PURE__ */ React.createElement(Flex, { ...rest, ref, className: clsx("kohler-coachmark-root", className) }, /* @__PURE__ */ React.createElement(
    Popover,
    {
      opened: dropdownOpened,
      trapFocus: false,
      position,
      withinPortal: false,
      withRoles: false,
      withArrow,
      id,
      disabled,
      onChange: setDropdownOpened
    },
    /* @__PURE__ */ React.createElement(Popover.Target, null, !disabled ? /* @__PURE__ */ React.createElement(
      Box,
      {
        component: "button",
        type: "button",
        ...targetCTA,
        className: clsx(classes.coachmarkDropdownTarget, "kohler-coachmark-target", targetCTA?.className),
        onClick: (e) => {
          setDropdownOpened(!dropdownOpened);
          targetCTA?.onClick?.(e);
        }
      },
      target
    ) : /* @__PURE__ */ React.createElement(Flex, { component: "div" }, target)),
    dropdown && /* @__PURE__ */ React.createElement(
      Popover.Dropdown,
      {
        onMouseDown: (event) => event.preventDefault(),
        className: clsx(coachmarkSizeClassNames[size], "kohler-coachmark-wrapper", coachmarkWrapperClassNames[variant])
      },
      /* @__PURE__ */ React.createElement(Typography, { size: "paragraph-small", component: "div", className: classes.dropdownWrapper }, /* @__PURE__ */ React.createElement(Flex, { className: contentColor }, dropdown), /* @__PURE__ */ React.createElement(
        Box,
        {
          component: "button",
          type: "button",
          "aria-label": "close popover",
          ...closeCTA,
          onClick: (e) => {
            setDropdownOpened(false);
            closeCTA?.onClick?.(e);
          },
          className: clsx(contentColor, closeCTA?.className)
        },
        /* @__PURE__ */ React.createElement(CloseIcon, { size: "small", withBoundingBox: true })
      ))
    )
  ));
});

export { Coachmark };
